<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
    <div v-if="loading_page === false">
      <div class="mt-6">
        <v-card elevation="6" class="pa-6">
          <v-slide-x-reverse-transition>
            <v-alert type="success" class="alert" v-if="alert_success === true">บันทึกข้อมูลเรียบร้อย !</v-alert>
            <v-alert type="error" class="alert" v-if="alert_danger === true">ไม่สามารถบันทึกได้ เนื่องจากคุณไม่ได้ถูกระบุให้นับสต็อกนี้ !</v-alert>
          </v-slide-x-reverse-transition>
          <div class="pa-4 mobile_grid" style="font-size: 24px">
            <div class="pr-2">การนับสต๊อก</div>
            <div><span class="pr-2">วันที่</span>{{ date_value }}</div>
          </div>
          <div class="pa-3">
            <div>
              <div>
                <div class="ml-1" style="font-size: 22px">เลขบาร์โค้ด / ชื่อสินค้า</div>
              </div>
            </div>
            <div class="mt-3 mr-1">
              <v-autocomplete no-data-text="ไม่พบข้อมูลที่ค้นหา" clearable color="#86bc3a" class="grid_btn cursor_focus" :autofocus="focus" ref="warehouse_count" :items="stock_product" item-text="search_product" item-value="loop_id" @input="add_stockProduct(search_stock)" v-model="search_stock" label="รายการ" prepend-inner-icon="mdi-archive" hide-details="auto" outlined></v-autocomplete>
            </div>
          </div>
        </v-card>
      </div>
      <div class="mt-6" v-if="search_stock !== null && search_stock !== ''">
        <v-card elevation="6" class="pa-6">
          <v-form ref="save_product" @submit.prevent="check_save">
            <div class="pa-4">
              <span style="font-size: 24px">{{ send_stock.search_product }}</span>
            </div>
            <div class="pa-3">
              <div>
                <div>
                  <div class="ml-1" style="font-size: 22px">จำนวนที่นับได้</div>
                </div>
              </div>
              <div class="mt-3 mr-1 grid_btn">
                <v-text-field clearable color="#86bc3a" type="number" @keypress="isOnlyNumber($event)" :rules="[v => !!v || 'กรุณากรอกจำนวนที่นับได้']" :autofocus="focus_numpad" label="กรุณากรอกจำนวนที่นับได้" v-model="send_stock.qty" hide-details="auto" outlined></v-text-field>
              </div>
            </div>
            <div class="text-right mt-4" v-if="this.$store.state.userDetail.count_warehouse_count === 1">
              <v-btn x-large class="grad-success-bg white--text btn_mobile" type="submit">บันทึก</v-btn>
            </div>
          </v-form>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import {onlyForNumber} from "@/js/handler";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: "Warehouse_count",
  data() {
    return {
      loading_page: false,
      search_stock: null,
      alert_success: false,
      alert_danger: false,
      clear_able: false,
      focus: true,
      focus_numpad: false,
      overlay: true,
      date_value: null,
      stock_list: [],
      stock_product: [],
      send_stock: [],
      query: false,
      show: false,
    }
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
    isOnlyNumber: function(evt) {
      return onlyForNumber(evt)
    },
    get_stock() {
      HTTP.post('/inventory/counts/stocklatest')
          .then((res) => {
            if (res.data.success === true) {
              this.stock_list = res.data.object
              let date_split = this.stock_list.count_date.split('-')
              let year = parseInt(date_split[0])
              let day = parseInt(date_split[2])
              let month = parseInt(date_split[1])
              if (day < 10){
                day = '0'+ day
              }
              let get_mouth = this.$store.state.monthList.find((data) => {
                return data.id === month
              })
              this.date_value = day+' '+get_mouth.name+' '+(year+543)
            }
          })
    },
    get_stockProduct() {
      this.loading_page = true
      HTTP.post('/inventory/counts/getstockproduct')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.overlay = false
              this.stock_product = res.data.object
              for (let index = 0; index < res.data.object.length; index++) {
                this.stock_product[index].loop_id = index + 1
              }
            }
          })
    },
    product_enter(evt, product_id) {
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode === 13 && (product_id === null || product_id === '' || product_id === undefined)) {
        evt.currentTarget.value = null
        return false
      }
      else {
        return true
      }
    },
    add_stockProduct(loop_id) {
      if (loop_id !== null && loop_id !== '' && loop_id !== undefined) {
        this.focus = false
        this.focus_numpad = true
        const value = this.stock_product.find((data) => data.loop_id === loop_id)
        this.send_stock = value;
      }
      else {
        this.search_stock = null
        this.focus = false
      }
    },
    check_save() {
      if (this.send_stock.qty > 9999) {
        Swal.fire({
          text: 'คุณกรอกจำนวนที่นับได้มากกว่า 9,999 แน่ใจใช่ไหมที่จะบันทึกค่านี้ ?',
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then((res) => {
          if (res.isConfirmed === true) {
            this.save_product()
          }
        })
      }
      else {
        this.save_product()
      }
    },
    async save_product() {
      if (this.$refs.save_product.validate()) {
        let send_data = {
          user_id: this.$store.state.userDetail.id,
          stock_id: this.send_stock.count_warehouse_id,
          stock_date: this.stock_list.count_date,
          stock_product_id: this.send_stock.product_id,
          barcode: this.send_stock.product_barcode,
          product_code: this.send_stock.product_code,
          product_detail: this.send_stock.product_name,
          qty: this.send_stock.quantity,
          qty_count: parseInt(this.send_stock.qty),
          unit_id: this.send_stock.unit_id,
          unit_qty: this.send_stock.unit_qty,
          unit_name: this.send_stock.unit_name,
          created_at: this.send_stock.created_at,
        }
        try {
          this.focus = true
          const response = await HTTP.post('/inventory/counts/stocksaveproduct', send_data)
          if (response.data.success === true) {
            this.search_stock = null
            this.alert_success = true
            this.send_stock.quantity = ''
            this.overlay = true
            this.$refs.warehouse_count.focus()
            await setTimeout(() => this.overlay, 1000)
            setTimeout(() => {
              this.alert_success = false
            }, 3000);
          }
          else if (response.data.success === false) {
            await Swal.fire({
              title: response.data.message,
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        }catch (error) {
          if (error.response.status == 404) {
            this.alert_danger = true
            this.overlay = true
            setTimeout(() => {
              this.alert_danger = false
              this.reloadPage()
            }, 1000);
          }
        }
      }
    }
  },
  beforeMount() {
    this.get_stock()
  },
  mounted() {
    this.get_stockProduct()
  },
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.grid_btn {
  display: grid;
  grid-template-columns: 50%;
}
.mobile_grid {
  display: flex;
}
.btn_mobile {
  font-size: 20px;
  width: 30%;
}
@media only screen and (max-width: 800px) {
  .grid_btn {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 500px) {
  .btn_mobile {
    font-size: 20px;
    width: 100%;
  }
  .mobile_grid {
    display: grid;
    grid-template-columns: 100%;
    text-align: center;
  }
}
</style>
